import { inject } from '@angular/core';
import { ActivatedRouteSnapshot, Router } from '@angular/router';
import { of, Observable, switchMap } from 'rxjs';
import { navigateToHome } from '../../../../../core/resolver/shared/functions/navigate-to-home.function';
import { ApplicationService } from '../../services/application/application.service';

export const ApplicationStateOrderStatusResolver = (
    route: ActivatedRouteSnapshot,
): Observable<boolean> => {
    const applicationService = inject(ApplicationService);

    const router = inject(Router);

    const applicationId = route.paramMap.get('id');

    if (!applicationId) {
        return navigateToHome(router);
    }

    return applicationService.getApplicationState(applicationId).pipe(
        switchMap((state) => {
            if (!state || state.orderId === null) {
                return navigateToHome(router);
            }

            return of(true);
        }),
    );
};
